import { plainToInstance, Type } from 'class-transformer'
import { User } from '../user'
import { IDocumentEngineTemplateQueryConfig } from './IDocumentEngineTemplateQueryConfig'
import { statuses } from '@core/theme/statuses'

export class DocumentEngineTemplateVersion {
  id: number
  status: 'DRAFT' | 'ACTIVE' | 'ARCHIVED'

  @Type(() => User)
  modifiedBy: User

  modifiedOn: Date
  queries: IDocumentEngineTemplateQueryConfig[]
  allowBypass: boolean
  allowExpiry: boolean

  static readonly statusConfig = {
    DRAFT: { color: statuses.draft.color, label: statuses.draft.label },
    ACTIVE: { color: statuses.active.color, label: statuses.active.label },
    ARCHIVED: {
      color: statuses.archived.color,
      label: statuses.archived.label,
    },
  } as const

  public static new(payload: unknown): DocumentEngineTemplateVersion {
    const entity = plainToInstance(DocumentEngineTemplateVersion, payload)
    return entity
  }
}
